import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import Button from "components/components/Button/Button";
import SectionLandingPage, {
  SectionLandingLink,
} from "components/components/SectionLandingPage/SectionLandingPage";
import { useErrorContext } from "contexts/ErrorContext";
import React from "react";
import { loginRequest } from "utils/authUtils";
import routeConstants from "utils/routeConstants";

const irisLink: SectionLandingLink = {
  title: "Insights Real-Time Information Service",
  to: routeConstants.iris,
  description:
    "IRIS is a near real-time, free, publicly available push service for accessing Insights Solution data. View the publicly accessible archive " +
    "or request credentials to get access within minutes.",
};

const remitLink: SectionLandingLink = {
  title: "Submit a REMIT report",
  to: routeConstants.remitSubmit,
  description:
    "REMIT (Regulation on wholesale Energy Markets Integrity and Transparency) data is the ‘inside information’ in respect of businesses or " +
    "facilities that market participants own or control (or are operationally responsible for) which they are obliged to publish before they " +
    "can trade on it. Submit REMIT files directly through Insights here.",
};

const links: SectionLandingLink[] = [irisLink, remitLink];

const UnauthenticatedView: React.FC = () => {
  const { instance } = useMsal();
  const { registerError } = useErrorContext();

  const handleLogin = async (): Promise<void> => {
    try {
      await instance.loginRedirect({
        redirectUri: "/my-insights",
        ...loginRequest,
      });
    } catch (e) {
      registerError();
    }
  };

  return (
    <div data-test-id="my-insights-unauthenticated-view">
      <SectionLandingPage
        title="My Insights"
        description="You need to log in to view this page."
      >
        <Button buttonText="Log in to Insights" onClick={handleLogin} />
      </SectionLandingPage>
    </div>
  );
};

const MyInsights: React.FC = () => (
  <>
    <AuthenticatedTemplate>
      <SectionLandingPage
        title="My Insights"
        description={<p>Welcome to My Insights.</p>}
        links={links}
      />
    </AuthenticatedTemplate>
    <UnauthenticatedTemplate>
      <UnauthenticatedView />
    </UnauthenticatedTemplate>
  </>
);

export default MyInsights;
